import styled from 'styled-components/macro';

import { distances } from '../../../styles/constants';

export const DateTimePickersWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    width: 75%;
    flex-wrap: wrap;

    > *:first-child {
        margin-right: ${distances.small};
    }

    @media (max-width: 768px) {
        display: block;
        width: 100%;

        > *:first-child {
            margin-right: 0;
        }

        > *:nth-child(2) {
            margin-right: 0;
        }
    }
`;
